import * as L from 'leaflet'
import { LatLngBounds } from 'leaflet'
import { arc } from '@map-sdk/sdk/plugins/weather/Typhoon/Arc'
import type { LatLng } from 'leaflet'
import type { MyMap } from '@map-sdk/sdk/ShipxyAPISDK'
import type { ArcInfo } from '@map-sdk/sdk/plugins/weather/Typhoon/TyphoonService'

interface TFQOptions extends L.PathOptions {
  color?: string
  fill?: boolean
  weight?: number
  opacity?: number
}

class TFQ extends L.Path {
  private _arcs: any[]
  private bounds: L.LatLngBounds[]
  private latlng!: L.LatLng

  constructor(
    latlng: L.LatLngLiteral | L.LatLng[],
    arcs: any[],
    options?: Partial<TFQOptions>
  ) {
    const option = {
      color: 'red',
      fill: true,
      weight: 1,
      opacity: 1,
      ...options,
    }
    super(option)
    L.Util.setOptions(this, option)
    this._setLatLngs(latlng as any)
    this.bounds = []
    this._update()
    this._arcs = arcs
  }

  getLatLngs(): L.LatLng[] {
    return [this.latlng]
  }

  private _setLatLngs(_latlng: LatLng): void {
    const _ = this as any
    _._bounds = new LatLngBounds([])
    this.latlng = L.latLng(_latlng)
    _._bounds.extend(this.latlng)
  }

  override setStyle(styleObject: Partial<TFQOptions>): this {
    return super.setStyle(styleObject)
  }

  protected _project(): void {
    const _ = this as any
    _._point = this._map.latLngToLayerPoint(this.latlng)
  }

  private _updateBounds(): void {
    const { _bounds, bounds } = this as any
    if (!bounds || bounds.length === 0) {
      throw new Error('bounds is null')
    }
    bounds.forEach((bound: any) => {
      _bounds.extend(bound)
    })
  }

  private _update(): void {
    if (this._map) {
      this._updateFenQuan()
      this._updateBounds()
    }
  }

  private _updateFenQuan() {
    if (!this._arcs || this._arcs.length === 0) {
      throw new Error('arcs is null')
    }

    const list: ArcInfo[] = []
    this._arcs.forEach((item) => {
      const arcInfo = arc(this.latlng, this._map as MyMap, item)
      list.push(arcInfo as any)
      this.bounds.push(arcInfo.bounds)
    })

    const listz = [] as any
    list.forEach((item: any, index) => {
      const nextIndex = (index + 1) % list.length
      const nextItem = list[nextIndex] as any
      if (index === 0) {
        listz.push([...item.path, `L${nextItem.start.x},${nextItem.start.y}`])
      } else {
        listz.push(
          item.path.slice(2).concat(`L${nextItem.start.x},${nextItem.start.y}`)
        )
      }
    })

    const { _renderer } = this as any
    listz.push('z' as any)
    _renderer._setPath(this, listz.flat().join(' '))
    _renderer._updateStyle(this.options as any) // 这里假设_renderer._updateStyle接受PathOptions
  }
}

// 类工厂方法
function createTFQ(
  latlng: L.LatLngLiteral | L.LatLng[],
  arcs: any[],
  options?: TFQOptions
): TFQ {
  return new TFQ(latlng, arcs, options)
}

// 导出类和工厂函数
export { createTFQ, TFQ }
